import { render, staticRenderFns } from "./DeletedPlaces.vue?vue&type=template&id=0171c9cf"
import script from "./DeletedPlaces.vue?vue&type=script&lang=js"
export * from "./DeletedPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports